export const TABLE_SORT = Object.freeze({
    ASSENDING: "assending",
    DESCENDING: "descending",
    DEFAULT_ORDER: "assending"
});

export const PRODUCT_TYPES = Object.freeze({
    EXTENSION: "Extension",
    THEME: "Theme",
    APP: "App",
    SHARED_PACKAGE: "Shared Package",
    SHARED_PACKAGE_DB: "shared_package",
    NEW_PRODUCT: "new"
});

export const JSON_PRODUCT_TYPE = Object.freeze({
    EXTENSION: "extension",
    THEME: "theme",
    APP: "app",
    SHARED_PACKAGE: "shared_package"
});

export const PRODUCT_TYPES_TO_JSON_PRODUCT_TYPES = Object.freeze({
    Extension: "extension",
    Theme: "theme",
    App: "app",
    "Shared Package": "shared_package"
});

export const JSON_PRODUCT_TYPES_TO_URL_PATH = Object.freeze({
    extension: "extensions",
    theme: "themes",
    app: "apps",
    shared_package: "sharedpackages"
});

export const PRODUCT_TYPES_TO_URL_PATH = Object.freeze({
    Extension: "extensions",
    Theme: "themes",
    App: "apps",
    "Shared Package": "sharedpackages"
});

export const JSON_PRODUCT_TYPES_TO_PRETTY_PLURAL = Object.freeze({
    extension: "Extensions",
    theme: "Themes",
    app: "Apps",
    shared_package: "Shared Packages"
});

export const PRODUCT_PLATFORM = Object.freeze({
    M1: "M1",
    M2: "M2"
});

export const PRODUCT_TEST_RESULT = Object.freeze({
    PASSED: "pass",
    FAILED: "fail"
});

export const PRODUCT_TEST_RESULT_STATES = Object.freeze({
    pass: "Pass",
    fail: "Fail",
    needs_review: "Needs Review",
    in_progress: "In Progress",
    error: "Error",
    unknown: "Unknown"
});

export const PRODUCT_TEST_TYPE = Object.freeze({
    PHPCS: "phpcs",
    COMPILE: "compile",
    VARNISH: "varnish",
    MANUAL_QA: "manual_qa",
    MARKETING: "marketing",
    PHPCPD: "phpcpd", // only for admin
    DIFF: "diff",
    PATCH: "patch",
    MALWARE: "malware",
    SVC: "svc",
    MFTFMAGENTO: "mftfmagento",
    MFTFVENDOR: "mftfvendor"
});

export const PRODUCT_TEST_PRETTY_NAMES = Object.freeze({
    PHPCS: "Code Sniffer",
    COMPILE: "Installation",
    VARNISH: "Installation & Varnish Test",
    MANUAL_QA: "Manual QA",
    MARKETING: "Marketing Review",
    PHPCPD: "Copy Paste Detector", // only for admin
    DIFF: "Diff Checker",
    PATCH: "Patch Checker",
    MALWARE: "Malware Scan",
    SVC: "Semantic Version Check",
    MFTFMAGENTO: "MFTF Adobe Commerce Supplied",
    MFTFVENDOR: "MFTF Vendor Supplied"
});

export const PRODUCT_TEST_MESSAGE_TYPES = Object.freeze({
    WARNING: "WARNING",
    ERROR: "ERROR"
});

export const SERVER_STRINGS = Object.freeze({
    TEMPORARY_SKU_PREFIX: "/temporary-"
});

export const IS_LOADING_API_URLS = `IS_LOADING_API_URLS`;

export const POLLING = "POLLING";

export const PRODUCT_STATES = Object.freeze({
    NEW: "PRODUCT_STATE_NEW",
    COMPLETE: "PRODUCT_STATE_COMPLETE",
    APPROVED: "PRODUCT_STATE_APPROVED"
});

export const UPLOAD_MALWARE_STATUS_STATES = Object.freeze({
    PASS: "pass",
    FAIL: "fail",
    IN_PROGRESS: "in_progress",
    ERROR: "error",
    UNKNOWN: "unknown"
});

export const PRODUCT_SUBMISSION_TYPE = Object.freeze({
    DRAFT: "draft",
    SUBMIT: "submit"
});

export const PRODUCT_SUBMISSION_MESSAGE_TYPE = Object.freeze({
    EXTENSION_THEME_TECHNICAL: "extension_theme_technical",
    EXTENSION_THEME_MARKETING: "extension_theme_marketing",
    SHARED_PACKAGE_TECHNICAL: "shared_package_technical"
});

export const EQP_ACTIONS = Object.freeze({
    DRAFT: "draft",
    SUBMIT: "submit",
    RECALL: "recall",
    CANCEL: "cancel"
});

export const ACTION_TYPES = Object.freeze({
    TECHNICAL: "technical",
    MARKETING: "marketing"
});

export const USER_PROFILE_SUBMISSION_TYPE = Object.freeze({
    DRAFT: "draft",
    SUBMIT: "submit"
});

export const ACTIONS_NOW_AVAILABLE_VERBS = {
    CANCEL: "cancel",
    REMOVE: "remove",
    DRAFT: "draft",
    SUBMIT: "submit",
    RECALL: "recall"
};

export const MARKETING_SUBMIT_WITHDRAW_BUTTON_STATES = {
    WITHDRAW_AND_EDIT: "withDrawAndEdit",
    WITHDRAW_AND_EDIT_DISABLED: "withDrawAndEditDisabled",
    SUBMIT: "submit",
    UPDATE: "update"
};

export const EQP_STATUS_OVERALL = Object.freeze({
    DRAFT: "draft",
    IN_PROGRESS: "in_progress",
    APPROVED: "approved",
    RELEASED_TO_STORE: "released_to_store",
    DEVELOPER_REMOVED_FROM_STORE: "developer_removed_from_store",
    ADMIN_REMOVED_FROM_STORE: "admin_removed_from_store",
    CANCELED_BY_DEVELOPER: "canceled_by_developer",
    CANCELED_BY_ADMIN: "canceled_by_admin"
});

export const EQP_STATUS_TECHNICAL = Object.freeze({
    UNKNOWN: "unknown",
    DRAFT: "draft",
    IN_AUTOMATION: "in_automation",
    AWAITING_MANUAL_QA: "awaiting_manual_qa",
    IN_MANUAL_QA: "in_manual_qa",
    APPROVED: "approved",
    RECALLED: "recalled",
    REJECTED: "rejected"
});

export const EQP_STATUS_MARKETING = Object.freeze({
    DRAFT: "draft",
    AWAITING_MARKETING_REVIEW: "awaiting_marketing_review",
    APPROVED_WITH_MODIFICATIONS_PENDING: "approved_with_modifications_pending",
    IN_MARKETING_REVIEW: "in_marketing_review",
    APPROVED: "approved",
    RECALLED: "recalled",
    REJECTED: "rejected"
});

export const EQP_STATUS_TRANSLATIONS = Object.freeze({
    in_automation: "Automated Testing in Progress",
    awaiting_manual_qa: "Awaiting Manual QA",
    in_manual_qa: "In Manual QA"
});

export const EQP_STATUS_TRANSLATIONS_OVERALL = Object.freeze({
    draft: "Draft",
    in_progress: "In Progress",
    approved: "Approved",
    released_to_store: "Released to Store",
    developer_removed_from_store: "Removed from Store",
    admin_removed_from_store: "Removed from Store",
    canceled_by_developer: "Cancelled",
    canceled_by_admin: "Cancelled"
});

export const EQP_STATUS_TRANSLATIONS_TECHNICAL = Object.freeze({
    draft: "Not Submitted",
    in_automation: "Automated Testing in Progress",
    awaiting_manual_qa: "Awaiting Manual QA",
    in_manual_qa: "In Manual QA",
    approved: "Passed Technical Review",
    rejected: "Failed Technical Review",
    recalled: "Not Submitted",
    canceled_by_admin: "Canceled",
    canceled_by_developer: "Canceled",
    released_to_store: "Passed Technical Review",
    developer_removed_from_store: "Passed Technical Review",
    admin_removed_from_store: "Passed Technical Review"
});

export const EQP_STATUS_TRANSLATIONS_MARKETING = Object.freeze({
    draft: "Not Submitted",
    awaiting_marketing_review: "Awaiting Marketing Review",
    approved_with_modifications_pending: "Waiting for Marketing Update Submission",
    in_marketing_review: "In Marketing Review",
    approved: "Passed Marketing Review",
    rejected: "Failed Marketing Review",
    recalled: "Not Submitted",
    canceled_by_admin: "Canceled",
    canceled_by_developer: "Canceled",
    released_to_store: "Passed Marketing Review",
    developer_removed_from_store: "Passed Technical Review",
    admin_removed_from_store: "Passed Technical Review"
});

export const EQP_STATUS_TRANSLATIONS_SHARED_PACKAGES = Object.freeze({
    approved: "Ready for use",
    awaiting_manual_qa: "Awaiting Manual QA",
    canceled_by_admin: "Canceled",
    canceled_by_developer: "Canceled",
    draft: "Waiting for Technical Submission",
    in_automation: "Automated Testing in Progress",
    in_manual_qa: "In Manual QA",
    recalled: "Waiting for Technical Submission",
    rejected: "Failed Technical Review"
});

export const PARTNER_LEVEL = {
    0: "none",
    1: "General Extension Developer + EE",
    2: "Premier Technology Partner",
    3: "Select Technology Partner",
    4: "General Extension Developer",
    5: "Enterprise Solution Partner",
    6: "Professional Solution Partner",
    7: "Premier Solution Partner",
    8: "Registered Solution Partner",
    9: "General Technology Partner",
    10: "Select Extensions Partner",
    11: "Premier Extensions Partner",
    12: "Global Elite Solution Partner",
    13: "Business Solution Partner",
    14: "Community Insider Partner",
    15: "Non-Partner",
    16: "Adobe Silver Technology Partner",
    17: "Adobe Gold Technology Partner",
    18: "Adobe Platinum Technology Partner",
    19: "Adobe Community Solution Partner",
    20: "Adobe Bronze Solution Partner",
    21: "Adobe Silver Solution Partner",
    22: "Adobe Gold Solution Partner",
    23: "Adobe Platinum Solution Partner",
    100: "We Are Adobe"
};

export const UPLOAD_TYPE = Object.freeze({
    PRODUCT_PACKAGE: "UPLOAD_TYPE__PRODUCT_PACKAGE",
    PRODUCT_DOCUMENTATION_USER: "UPLOAD_TYPE__PRODUCT_DOCUMENTATION_USER",
    PRODUCT_DOCUMENTATION_INSTALLATION: "UPLOAD_TYPE__PRODUCT_DOCUMENTATION_INSTALLATION",
    PRODUCT_DOCUMENTATION_REFERENCE: "UPLOAD_TYPE__PRODUCT_DOCUMENTATION_REFERENCE"
});

export const UPLOAD_TYPE_API_FIELD = Object.freeze({
    PRODUCT_DOCUMENTATION_USER: "user",
    PRODUCT_DOCUMENTATION_INSTALLATION: "installation",
    PRODUCT_DOCUMENTATION_REFERENCE: "reference"
});

export const UPLOAD_FILE_TYPES = Object.freeze({
    JPEG: "image/jpeg",
    GIF: "image/gif",
    PNG: "image/png",
    PDF: "application/pdf",
    TGZ: "application/gzip,application/tar,application/tar+gzip,application/x-tgz,application/tgz,application/x-tar+gzip",
    ZIP: "application/zip,application/x-zip-compressed",

    ALL_IMAGES: "image/jpeg,image/gif,image/png"
});

export const UPLOAD_FILE_TYPE_EXTENSIONS = Object.freeze({
    ALL: "*",
    JPEG: "jpeg",
    GIF: "gif",
    PNG: "png",
    PDF: "pdf",
    TGZ: "tgz",
    ZIP: "zip"
});

export const LICENSE_TYPE_VALUE = Object.freeze({
    CUSTOM: "custom",
    AFL: "afl",
    APACHE: "apache",
    BSD: "bsd",
    GNU_GPL: "gnu-gpl",
    GNU_LGPL: "gnu-lgpl",
    MIT: "mit",
    MOZILLA: "mozilla",
    OSL: "osl"
});

export const LICENSE_TYPE_NAME = Object.freeze({
    CUSTOM: "Custom License",
    AFL: "Academic Free License 3.0 (AFL)",
    APACHE: "Apache License 2.0",
    BSD: "BSD 2-Clause License",
    GNU_GPL: "GNU General Public License 3.0 (GPL-3.0)",
    GNU_LGPL: "GNU Lesser General Public License 3.0 (LGPL-3.0)",
    MIT: "MIT License (MIT)",
    MOZILLA: "Mozilla Public License 1.1 (MPL-1.1)",
    OSL: "Open Software License 3.0 (OSL-3.0)"
});

export const SAAS_INTEGRATION_VALUES = Object.freeze({
    BOTH: "both",
    NONE: "none",
    SELF: "self",
    THIRD_PARTY: "3rd_party",
    UNKNOWN: "unknown"
});

export const SUPPORT_TIERS_MONTHLY_PERIOD_VALUES = Object.freeze({
    M1: "1",
    M3: "3",
    M6: "6",
    M9: "9",
    M12: "12",
});
export const SUPPORT_TIERS_MONTHLY_PERIOD_NAMES = Object.freeze({
    M1: "1 Month",
    M3: "3 Months",
    M6: "6 Months",
    M9: "9 Months",
    M12: "12 Months"
});

export const API_ERROR_CODES = Object.freeze({
    PROCESS_AS_PATCH: 300
});

//TODO//These should probably be moved to the "Messages" file//JRP//
export const ICON_REQUIRED = "An icon image is required.";
export const GALLERY_IMAGE_REQUIRED = "Need Two Gallery Images.";
export const MINIMUM_GALLARY_IMAGE_ERROR = product_type =>
    `Need At Least 2 ${product_type} Images`;
export const ICON_MALWARE = "The malware must pass.";
export const GALLERY_IMAGE_MALWARE = "Gallery Image needs to pass Malware test.";

export const LICENSE_TYPE_REQUIRED = "Please enter a license type.";
export const LICENSE_CUSTOM_NAME_REQUIRED = "Please enter a license Name.";
export const LICENSE_CUSTOM_TYPE_URL_REQUIRED = "Please enter a license url.";
export const LICENSE_CUSTOM_TYPE_VALID_URL_REQUIRED = "Please enter a valid url.";
export const VALID_URL_REQUIRED = "Please enter a valid url.";

export const ADDITIONAL_DETAILS_OTHER_OPTIONS = {
    released_with_setup_scripts: "Released with setup scripts",
    included_service_contracts: "Service contracts included",
    included_external_service_contracts: "External service contracts included",
    custom_implementation_ui: "Custom UI implementation",
    support_web_api: "Web API supported",
    support_test_coverage: "Test coverage supported",
    support_responsive_design: "Responsive design supported"
};
export const ADDITIONAL_DETAILS_OTHER_OPTIONS_ORDER = [
    "released_with_setup_scripts",
    "included_service_contracts",
    "included_external_service_contracts",
    "custom_implementation_ui",
    "support_web_api",
    "support_test_coverage",
    "support_responsive_design"
];

export const SOCIAL_NETWORK_LABELS = {
    github_username: "GitHub",
    stackexchange_url: "Stack Exchange",
    facebook_url: "Facebook",
    twitter: "Twitter",
    linkedin_url: "LinkedIn"
};
export const SOCIAL_NETWORK_PLACEHOLDER = {
    github_username: "Enter profile URL",
    stackexchange_url: "Enter profile URL",
    facebook_url: "Enter profile URL",
    twitter: "Enter profile URL",
    linkedin_url: "Enter profile URL"
};
export const SOCIAL_NETWORK_ORDER = [
    "github_username",
    "stackexchange_url",
    "facebook_url",
    "twitter",
    "linkedin_url"
];

export const SHARED_PACKAGE_FILTER_OPTIONS = [
    {key:"Submission in Progress", value: "submission_in_progress"},
    {key:"Approved", value: "approved"}
];

export const PRODUCT_FILTER_OPTIONS = [
    {key:"Adobe Commerce 1 (M1)", value: PRODUCT_PLATFORM.M1},
    {key:"Adobe Commerce 2 (M2)", value: PRODUCT_PLATFORM.M2},
    {key:"Submission in Progress", value: "submission_in_progress"},
    {key:"Product Live", value: "product_live"}
];

export const MAGENTO_COMMERCE_TYPES = Object.freeze({
    CLOUD       : "Adobe Commerce (cloud)",
    COMMERCE    : "Adobe Commerce (on-prem)",
    OPEN_SOURCE : "Magento Open Source"
});

export const PAGEBUILDER_OPTIONS = {
    page_builder_new_content_type: "New Content Type",
    page_builder_extends_content_type: "Extends Content Type",
    page_builder_used_for_content_creation: "Uses Page Builder for Content Creation",
};
export const PAGEBUILDER_OPTIONS_ORDER = [
    "page_builder_new_content_type",
    "page_builder_extends_content_type",
    "page_builder_used_for_content_creation",
];

// ORIGINAL: Magento Partner Levels
// export const COMMERCE_LEVELS_ARRAY = [1,2,3,5,6,7,8,9,10,11,12,13,14]; // we exclude 0, 4 and anything greater than 14 - As per Magento Partners Program
// ...
// NEW: Adobe Partner Levels
export const COMMERCE_LEVELS_ARRAY = [15,16,17,18,20,21,22,23,100]; //  As per Adobe Partners Program ... note that 19 is no longer used (was 'Adobe Community Solution Partner')

export const PRODUCT_POLLING_INTERVAL = 30000;

export const PRICING_TYPE = Object.freeze({
    SUBSCRIPTION: "subscription",
    ONETIME: "one-time"
});

export const DEFAULT_CUSTOM_LICENSE_NAME = 'Custom License';
